const PROMPT_KEY = '__mosqifyDeferredPrompt';

export function getDeferredInstallPrompt() {
  if (typeof window === 'undefined') return null;
  return window[PROMPT_KEY] || null;
}

export function setDeferredInstallPrompt(promptEvent) {
  if (typeof window === 'undefined') return;
  window[PROMPT_KEY] = promptEvent || null;
}

export function clearDeferredInstallPrompt() {
  if (typeof window === 'undefined') return;
  window[PROMPT_KEY] = null;
}
